export default "__VITE_ASSET__z$Nv4mXU__"